// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2kIiM","bigColWidth":"Table_bigColWidth__17Sab","biggerColWidth":"Table_biggerColWidth__3rf8d","row":"Table_row__3VWUK","col":"Table_col__1iNpw"};